const ShippingAPI = {
  getShippingMethods (barangay_code) {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/shipping_method.php', {
        method: 'POST',
        body: JSON.stringify({ 'barangay_code': barangay_code })
      })
		    .then(response => response.json())
		    resolve(response)
    })
  },
  getShippingFee (province_code, city_code, barangay_code, delivery_type, total_order_weight, products, login_id, voucher_code) {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/shipping_fee.php', {
        method: 'POST',
        body: JSON.stringify({ 'province_code': province_code,
        'city_code': city_code,
        'barangay_code': barangay_code,
        'delivery_type': delivery_type,
        'total_order_weight': total_order_weight,
        'products' : products,
        'login_id' : login_id,
        'voucher_code': voucher_code })
      })
        .then(response => response.json())
        resolve(response)
    })
  },
  getShippingTime () {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/shipping_time.php', {
        method: 'GET',
      })
        .then(response => response.json())
        resolve(response)
    })
  },
}
export default ShippingAPI



// WEBPACK FOOTER //
// ./src/api/shipping.js